export default "__VITE_ASSET__DP2qbvYJ__"